import apiClient from '@/api/client';

export interface NotificationResponse {
  id: string;
  user_id: string;
  title: string;
  body: string;
  type: string;
  reference_type: string | null;
  reference_id: string | null;
  is_read: boolean;
  read_at: string | null;
  created_at: string;
}

export interface UserSearchResult {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
}

export interface BroadcastPayload {
  title: string;
  body: string;
  send_email: boolean;
  company_only: boolean;
}

export interface BroadcastResult {
  in_app_sent: number;
  email_sent: number;
  email_failed: number;
  total_recipients: number;
}

export const notificationsApi = {
  list: (params?: { is_read?: boolean; page?: number; per_page?: number }) =>
    apiClient.get<{ items: NotificationResponse[]; total: number }>('/notifications', { params }),
  unreadCount: () =>
    apiClient.get<{ unread_count: number }>('/notifications/unread-count'),
  markRead: (id: string) =>
    apiClient.post<NotificationResponse>(`/notifications/${id}/read`),
  markAllRead: () =>
    apiClient.post<{ updated: number }>('/notifications/read-all'),
  searchUsers: (q: string) =>
    apiClient.get<UserSearchResult[]>('/notifications/users/search', { params: { q } }),
  send: (data: { recipient_id: string; title: string; body?: string }) =>
    apiClient.post<{ status: string; recipient_id: string }>('/notifications/send', data),
  broadcast: (data: BroadcastPayload) =>
    apiClient.post<BroadcastResult>('/notifications/broadcast', data),
};
